var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRuleForklift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38477 2H7.93477L11.3848 8H7.88477L6.38477 6H2.38477V2Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3848 2H12.3848V11H11.3848V8.99993H7.38477L5.88477 6.99993H1.38477V13.9999H1.88477C1.88477 12.8954 2.7802 11.9999 3.88477 11.9999C4.98934 11.9999 5.88477 12.8954 5.88477 13.9999H6.88477C6.88477 12.8954 7.7802 11.9999 8.88477 11.9999C9.98934 11.9999 10.8848 12.8954 10.8848 13.9999H11.3848V12H12.3848V14H13.3848H15.3848V13H13.3848V12V11V2ZM8.88477 12.9999C9.43705 12.9999 9.88477 13.4476 9.88477 13.9999H7.88477C7.88477 13.4476 8.33248 12.9999 8.88477 12.9999ZM4.88477 13.9999C4.88477 13.4476 4.43705 12.9999 3.88477 12.9999C3.33248 12.9999 2.88477 13.4476 2.88477 13.9999H4.88477Z",
    fill: "#CCCFD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88477 14C4.88477 14.5523 4.43705 15 3.88477 15C3.33248 15 2.88477 14.5523 2.88477 14C2.88477 13.4477 3.33248 13 3.88477 13C4.43705 13 4.88477 13.4477 4.88477 14Z",
    fill: "#CCCFD1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88477 14C9.88477 14.5523 9.43705 15 8.88477 15C8.33248 15 7.88477 14.5523 7.88477 14C7.88477 13.4477 8.33248 13 8.88477 13C9.43705 13 9.88477 13.4477 9.88477 14Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRuleForklift);
export default __webpack_public_path__ + "static/media/icon-rule-forklift.e575827376a5d0b36ef4ced72bd30a41.svg";
export { ForwardRef as ReactComponent };